import * as React from "react";

import "./ai-banner.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {AiSparklesSvg} from "./ai-sparkles-svg";

export const AiBanner = ({isCC=false}) => cs(
    ["closed", (_, next) => UseState({initValue: false, next})],
    ({closed}) => !closed.value && (
        <div className="ai-banner-js7">
            <div className="sparkle-icon-container">
                {AiSparklesSvg()}
            </div>
            <div className="text-container">
                Powerful writing tools are just a click away.
                {isCC ? <br/> : " "}
                Look for the sparkle icon to access tools that effortlessly generate, enhance, and refine your text.
            </div>

            <div
                className="close-btn"
                onClick={() => closed.onChange(true)}
            >
                &times;
            </div>
        </div>
    )
);

